import { ca } from '@cian/analytics';

export const trackDealButtonClick = (isBrokerAvailable: boolean) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'BrokerDeal',
    action: 'Click',
    label: 'BrokerDealButton',
    user: {
      extra: {
        has_registration: isBrokerAvailable,
      },
    },
  });
};
